import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CATEGORY_LABELS = {
  administratif: "Administratif",
  finance: "Finance",
  sante: "Santé",
  auto: "Auto & Transport",
  famille: "Famille",
  "vie-pratique": "Vie Pratique",
};

const FALLBACK_IMAGE =
  "https://images.unsplash.com/photo-1615749356515-6b07ae5d5378?w=400&q=70";

export default function RelatedArticles({ articles }) {
  if (!articles || articles.length === 0) return null;

  return (
    <section data-testid="related-articles" className="mt-10 pt-8 border-t border-slate-200">
      <h2 className="font-heading text-xl sm:text-2xl font-bold text-slate-900 mb-6">
        Articles liés
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {articles.map((article) => (
          <Link
            key={article.slug}
            to={`/article/${article.slug}`}
            data-testid={`related-article-${article.slug}`}
            className="flex gap-3 p-4 bg-white border border-slate-200 rounded-xl hover:border-blue-200 hover:shadow-md transition-all duration-200"
          >
            <div className="flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden bg-slate-100">
              <img
                src={article.featured_image || FALLBACK_IMAGE}
                alt={article.title}
                className="w-full h-full object-cover"
                loading="lazy"
                onError={(e) => { e.target.src = FALLBACK_IMAGE; }}
              />
            </div>
            <div className="flex-1 min-w-0">
              <span className="text-xs font-semibold text-blue-600 uppercase tracking-wide">
                {CATEGORY_LABELS[article.category] || article.category}
              </span>
              <p className="text-sm font-semibold text-slate-800 line-clamp-2 leading-snug mt-0.5">
                {article.title}
              </p>
            </div>
            <ArrowRight className="w-4 h-4 text-slate-400 flex-shrink-0 mt-1" />
          </Link>
        ))}
      </div>
    </section>
  );
}
